import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { DonutChart } from '@warrenbrasil/nebraska-web';
import { AllocationChartSummary } from './components/AllocationChartSummary';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { IAllocationChartData } from './types';

interface Props {
  allocation: IAllocationChartData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationChart',
  props: {
    allocation: null
  },
  setup(__props: any) {

const props = __props as {
  allocation: IAllocationChartData;
};



const selectedSectionIndex = ref<number | null>(null);

const dataSet = computed(() => {
  return props.allocation.sections.map(section => ({
    name: section.name,
    color: section.color,
    y: section.percentageAllocatedOnPortfolio.value
  }));
});

const chartSummaryData = computed(() => {
  if (selectedSectionIndex.value === null) {
    return {
      title: props.allocation.hoverInformation.title,
      subtitle: props.allocation.hoverInformation.subtitle
    };
  }

  const sectionSelected = props.allocation.sections[selectedSectionIndex.value];

  return {
    title: sectionSelected.hoverInformation.title,
    subtitle: sectionSelected.hoverInformation.subtitle
  };
});

const onHoverAllocation = (index: number | null) => {
  selectedSectionIndex.value = index;
};

return { __sfc: true,props, selectedSectionIndex, dataSet, chartSummaryData, onHoverAllocation, DonutChart, AllocationChartSummary, NebraskaColors }
}

})